import { render } from "./header.vue?vue&type=template&id=3ae798a2&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=3ae798a2&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=1&id=3ae798a2&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=2&id=3ae798a2&lang=less&scoped=true"
import "./header.vue?vue&type=style&index=3&id=3ae798a2&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae798a2"]])

export default __exports__